export default class Modal {
  constructor() {

    // モーダル操作
    $('.js-modal').on('click', function(e) {
      $(e.currentTarget).addClass('is-hidden');
    });

    $('.js-closeModal').on('click', function(e) {
      $(e.currentTarget).parents('.js-modal').addClass('is-hidden');
    });

    $('.js-modalInner').children().on('click', function(e) {
      e.stopPropagation();
    });

    var sameTab = sessionStorage.getItem('sameTab')
    if (sameTab) {
      $('body').addClass('is-modal-hidden');
    } else {
      $('body').removeClass('is-modal-hidden');
      sessionStorage.setItem('sameTab', true);
    }
  }
}
